<div class="border border-[#DEE2E6] rounded-2xl p-4 w-full ">
    <div class="flex items-center w-full">
        <div
            class="w-11 h-11 p-4 bg-white rounded-full border-8 border-sky-100 flex-col justify-center items-center gap-2.5 inline-flex">
            <div class="text-white text-base font-bold  leading-none">

                @if(type === 'departure') {
                @if(optionsConfig?.parking == true && optionsConfig?.flight == true && optionsConfig?.transfer ==
                true) {
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.51937 15.7149H20.5194V17.7149H1.51937V15.7149ZM21.0894 6.35491C20.8794 5.55491 20.0494 5.07491 19.2494 5.29491L13.9394 6.71491L7.01937 0.284912L5.10938 0.794912L9.24937 7.96491L4.27938 9.29491L2.30937 7.75491L0.859375 8.14491L2.67938 11.3049L3.44937 12.6349L5.04938 12.2149L10.3594 10.7849L14.7094 9.62491L20.0194 8.21491C20.8294 7.97491 21.2994 7.15491 21.0894 6.35491Z"
                        fill="#0040DD" />
                </svg>
                }

                @if(optionsConfig?.parking == true && optionsConfig?.flight == false && optionsConfig?.transfer ==
                false) {
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2 L4 5 V6 L12 3 L20 6 V5 L12 2Z" fill="#0040DD" />
                    <path
                        d="M18.92 8.01C18.72 7.42 18.16 7 17.5 7H6.5C5.84 7 5.28 7.42 5.08 8.01L3 14V22C3 22.55 3.45 23 4 23H5C5.55 23 6 22.55 6 22V21H18V22C18 22.55 18.45 23 19 23H20C20.55 23 21 22.55 21 22V14L18.92 8.01Z"
                        fill="#0040DD" />
                    <path d="M6.5 9H17.5L19 13H5L6.5 9Z" fill="white" />
                    <circle cx="7.5" cy="17.5" r="1.5" fill="white" />
                    <circle cx="16.5" cy="17.5" r="1.5" fill="white" />
                </svg>
                }
                }

                @if(type === 'arrival') {
                @if(optionsConfig?.parking == true && optionsConfig?.flight == true && optionsConfig?.transfer ==
                true) {
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.5 17.5H19.5V19.5H0.5V17.5ZM7.68 11.77L12.03 12.93L17.34 14.35C18.14 14.56 18.96 14.09 19.18 13.29C19.39 12.5 18.92 11.67 18.12 11.45L12.81 10.03L10.05 1L8.12 0.5V8.78L3.15 7.45L2.22 5.13L0.77 4.74V9.91L2.37 10.34L7.68 11.77Z"
                        fill="#0040DD" />
                </svg>
                }

                @if(optionsConfig?.parking == true && optionsConfig?.flight == false && optionsConfig?.transfer ==
                false) {
                <svg width="22" height="22" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                        <path
                            d="M14.8409 8.48215H14.8241L13.4891 5.47834C13.3644 5.19825 13.1612 4.9603 12.9041 4.79326C12.647 4.62622 12.347 4.53725 12.0404 4.53711H4.95968C4.6531 4.53727 4.35313 4.62625 4.09605 4.79329C3.83897 4.96033 3.63579 5.19827 3.51108 5.47834L2.17599 8.48215H2.15911C1.87892 8.48246 1.6103 8.5939 1.41218 8.79203C1.21405 8.99015 1.10261 9.25877 1.10229 9.53896V13.2378C1.10261 13.518 1.21405 13.7866 1.41218 13.9848C1.6103 14.1829 1.87892 14.2943 2.15911 14.2946V15.6337C2.15936 15.8438 2.24294 16.0453 2.39153 16.1939C2.54013 16.3425 2.74159 16.4261 2.95173 16.4263H4.80116C5.0113 16.4261 5.21276 16.3425 5.36135 16.1939C5.50994 16.0453 5.59353 15.8438 5.59377 15.6337V14.2946H11.4063V15.6337C11.4065 15.8438 11.4901 16.0453 11.6387 16.1939C11.7873 16.3425 11.9887 16.4261 12.1989 16.4263H14.0483C14.2585 16.4261 14.4599 16.3425 14.6085 16.1939C14.7571 16.0453 14.8407 15.8438 14.8409 15.6337V14.2946C15.1211 14.2943 15.3897 14.1829 15.5879 13.9848C15.786 13.7866 15.8974 13.518 15.8977 13.2378V9.53896C15.8974 9.25877 15.786 8.99015 15.5879 8.79203C15.3897 8.5939 15.1211 8.48246 14.8409 8.48215Z"
                            fill="#0040DD" />
                        <path
                            d="M4.47668 5.90767C4.51826 5.81429 4.586 5.73496 4.67172 5.67928C4.75744 5.6236 4.85746 5.59395 4.95968 5.59393H12.0404C12.1426 5.59398 12.2425 5.62364 12.3282 5.67932C12.4139 5.735 12.4817 5.81431 12.5232 5.90767L13.6674 8.48211H3.33248L4.47668 5.90767Z"
                            fill="white" />
                        <rect x="3.2159" y="10.8777" width="2.64204" height="1.05683" fill="white" />
                        <rect x="11.142" y="10.8777" width="2.6421" height="1.05683" fill="white" />
                        <path
                            d="M8.49999 0.532715L0.573853 3.71516V4.85398L8.49999 1.67157L16.4261 4.85398V3.71516L8.49999 0.532715Z"
                            fill="#0040DD" />
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <rect width="16.9091" height="16.9091" x="0.045" y="0.045" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                }
                }
            </div>
        </div>
        <p class="font-bold text-base leading-4 ml-2">
            {{
            ((site === 'skavsta' || site === 'quality-xpo-arlanda' || site === 'aiden-short-term') ? (type == 'arrival'
            ?
            "PARKIFLY.SIMPLE_SEARCH_SELECT.ARRIVAL_HEADING" :
            'PARKIFLY.SIMPLE_SEARCH_SELECT.DEPARTURE_HEADING') :
            (type == 'arrival' ? "PARKIFLY.CHOOSE_PARKING.ARRIVAL" : 'PARKIFLY.CHOOSE_PARKING.DEPARTURE')) | transloco
            }}
        </p>
    </div>
    <div
        class="mt-4 bg-[#F7F7F7] rounded-2xl p-4 w-full divide-y divide-[#DEE2E6] grid xl:grid-rows-1 xl:grid-cols-3 xl:divide-x xl:divide-y-0">
        <!-- Går kanske att köra en loop här istället för 3 divs beroende på beslut om innehåll -->
        @if(optionsConfig?.parking !== false) {
        <div>
            <div class="ml-2 pb-1 pt-3 xl:p-0">
                <p class="text-sm leading-[14px] font-bold text-[#1B3777] xl:mt-0 display-flex justify-between"
                    class="display-flex">
                    {{(type == 'arrival' ? 'PARKIFLY.CHOOSE_PARKING.PARKING_TO': 'PARKIFLY.CHOOSE_PARKING.PARKING_FROM')
                    | transloco}}
                    @if(showParkingTooltip) {
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="mr-2">
                        <path
                            d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.6875 5.625C9.87292 5.625 10.0542 5.67998 10.2084 5.783C10.3625 5.88601 10.4827 6.03243 10.5536 6.20373C10.6246 6.37504 10.6432 6.56354 10.607 6.7454C10.5708 6.92725 10.4815 7.0943 10.3504 7.22541C10.2193 7.35652 10.0523 7.44581 9.8704 7.48199C9.68854 7.51816 9.50004 7.49959 9.32874 7.42864C9.15743 7.35768 9.01101 7.23752 8.908 7.08335C8.80499 6.92918 8.75 6.74792 8.75 6.5625C8.75 6.31386 8.84878 6.0754 9.02459 5.89959C9.20041 5.72377 9.43886 5.625 9.6875 5.625ZM10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z"
                            fill="#0040DD" />
                        @if(type === 'arrival' && !psfCardInfo.hotel) {
                        <title>
                            {{'PARKIFLY.CHOOSE_PARKING.EXTENDED_PARKING' | transloco}}
                        </title>
                        }
                        @if(type === 'departure' && !psfCardInfo.hotel) {
                        <title>
                            {{'PARKIFLY.CHOOSE_PARKING.EXTENDED_PARKING' | transloco}}
                        </title>
                        }
                    </svg>
                    }
                </p>
                <div class="mt-3">
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{day | transloco}}</p>
                    @if(type === 'arrival') {
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0">{{parkingDate + ' ' +
                        ("PARKIFLY.CLOCK_SHORT" | transloco) + ': ' + parkingTime}}</p>
                    }@else {
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0">{{parkingDate + ' ' +
                        ("PARKIFLY.CLOCK_SHORT" | transloco) + ': ' + parkingTime}}</p>
                    }
                </div>
            </div>
        </div>
        }
        @if(optionsConfig?.transfer !== false) {
        <div>
            <div class="ml-2 pb-1 pt-3 xl:p-0">
                <p class="text-sm leading-[14px] font-bold text-[#1B3777] flex justify-between items xl:mt-0">
                    Shuttle
                    @if(showTooltip) {
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="mr-2">
                        <path
                            d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.6875 5.625C9.87292 5.625 10.0542 5.67998 10.2084 5.783C10.3625 5.88601 10.4827 6.03243 10.5536 6.20373C10.6246 6.37504 10.6432 6.56354 10.607 6.7454C10.5708 6.92725 10.4815 7.0943 10.3504 7.22541C10.2193 7.35652 10.0523 7.44581 9.8704 7.48199C9.68854 7.51816 9.50004 7.49959 9.32874 7.42864C9.15743 7.35768 9.01101 7.23752 8.908 7.08335C8.80499 6.92918 8.75 6.74792 8.75 6.5625C8.75 6.31386 8.84878 6.0754 9.02459 5.89959C9.20041 5.72377 9.43886 5.625 9.6875 5.625ZM10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z"
                            fill="#0040DD" />
                        <title>{{(type == 'arrival' ? 'PARKIFLY.CHOOSE_PARKING.TRANSFER_FROM_TERMINAL5' :
                            'PARKIFLY.CHOOSE_PARKING.TRANSFER_TO_TERMINAL5') | transloco}}</title>
                    </svg>
                    }
                </p>
                <div [ngClass]="{'mt-2' : (showTooltip && psfCardInfo.flightId != ''), 'mt-3' : !showTooltip}">
                    <p class="text-sm leading-5 text-gray-600 mb-[6px] truncate"
                        title="{{(psfCardInfo.transferLocation && type == 'arrival') ? psfCardInfo.transferLocation : ''}}">
                        {{type == 'arrival' ? ('PARKIFLY.CHOOSE_PARKING.FROM' | transloco) + ' ' +
                        psfCardInfo.transferLocation :
                        ('PARKIFLY.CHOOSE_PARKING.FROM_PARKING' | transloco)}}
                    </p>
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0 truncate"
                        title="{{(psfCardInfo.transferLocation && type != 'arrival') ? psfCardInfo.transferLocation : ''}}">
                        {{(type == 'arrival' ? ('PARKIFLY.CHOOSE_PARKING.TO_PARKING' | transloco) :
                        ('PARKIFLY.CHOOSE_PARKING.TO' |
                        transloco ) + ' ' + psfCardInfo.transferLocation)}}
                    </p>
                    @if(site == 'quality' || site == 'aiden') {
                    <p class="text-sm leading-5 text-gray-600 mb-[6px] truncate"
                        title="{{(psfCardInfo.transferDateTime && type == 'arrival') ? psfCardInfo.transferDateTime : ''}}">
                        {{ psfCardInfo.transferDateTime | date:'yyyy-MM-dd' }}
                        {{ ' ' + ('PARKIFLY.CLOCK_SHORT' | transloco) + ' ' }}
                        {{ psfCardInfo.transferDateTime | date:'HH:mm' }}
                    </p>
                    }
                </div>
            </div>
        </div>
        }
        @if(optionsConfig?.flight !== false) {
        <div>
            <div class="ml-2 pb-1 pt-3 xl:p-0">
                <p class="text-sm leading-[14px] font-bold text-[#1B3777] xl:mt-0">
                    {{(type == 'arrival' ? ( psfCardInfo.flightId == '' ?
                    'PARKING_ORDER_TIME_EDIT.SHUTTLE_DATE' :
                    'PARKIFLY.CHOOSE_PARKING.ARRIVING_FLIGHT'):
                    ( psfCardInfo.hotel ? 'PARKING_ORDER_TIME_EDIT.SHUTTLE_DATE' :
                    'PARKIFLY.CHOOSE_PARKING.DEPARTING_FLIGHT')) |
                    transloco}}
                </p>
                @if(type == 'departure'){
                @if(psfCardInfo.hotel){
                <div class="mt-3">
                    @if(site == 'quality' || site == 'aiden'){
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{ transferWeekdayKey |
                        transloco }}
                    </p>
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0">
                        {{ psfCardInfo.transferDateTime | date:'yyyy-MM-dd' }}
                        {{ ' ' + ('PARKIFLY.CLOCK_SHORT' | transloco) + ' ' }}
                        {{ psfCardInfo.transferDateTime | date:'HH:mm' }}
                    </p>
                    } @else{
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{ day |
                        transloco }}
                    </p>
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0">{{parkingDate + ' ' +
                        ("PARKIFLY.CLOCK_SHORT" | transloco) + ': ' + parkingTime}}
                    </p>
                    }
                </div>
                } @else{
                <div class="mt-3">
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{ day |
                        transloco }}
                    </p>
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">
                        {{psfCardInfo.flightId ? psfCardInfo.flightId : ''}} |
                        {{psfCardInfo.flightDate ? (psfCardInfo.flightDate | date : "yyyy-MM-dd HH:mm") : ''}}
                    </p>
                    <p class="text-sm leading-6 text-black mt-[6px] mb-[6px] xl:mb-0">{{psfCardInfo.location ? (((type
                        ==
                        'arrival' ? 'PARKIFLY.CHOOSE_PARKING.FROM' : 'PARKIFLY.CHOOSE_PARKING.TO') | transloco) + ' ' +
                        psfCardInfo.location) : '-'}}</p>
                </div>
                }
                }

                @if(type == 'arrival'){
                @if(site == 'quality' || site == 'aiden'){
                @if(psfCardInfo.flightId != ""){
                <div class="mt-3">
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{ transferWeekdayKey | transloco }}
                    </p>
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">
                        {{psfCardInfo.flightId ? psfCardInfo.flightId : ''}} |
                        {{psfCardInfo.flightDate ? (psfCardInfo.flightDate | date : "yyyy-MM-dd HH:mm") : ''}}
                    </p>
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0">{{psfCardInfo.location ? (((type ==
                        'arrival' ? 'PARKIFLY.CHOOSE_PARKING.FROM' : 'PARKIFLY.CHOOSE_PARKING.TO') | transloco) + ' ' +
                        psfCardInfo.location) : '-'}}</p>
                </div>
                } @else {
                <div class="mt-3">
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{ transferWeekdayKey | transloco }}
                    </p>
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0">
                        {{ psfCardInfo.transferDateTime | date:'yyyy-MM-dd' }}
                        {{ ' ' + ('PARKIFLY.CLOCK_SHORT' | transloco) + ' ' }}
                        {{ psfCardInfo.transferDateTime | date:'HH:mm' }}
                    </p>
                </div>
                }
                } @else{
                @if(psfCardInfo.flightId != ""){
                <div class="mt-3">
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{ day |
                        transloco }}
                    </p>
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">
                        {{psfCardInfo.flightId ? psfCardInfo.flightId : ''}} |
                        {{psfCardInfo.flightDate ? (psfCardInfo.flightDate | date : "yyyy-MM-dd HH:mm") : ''}}
                    </p>
                    <p class="text-sm leading-6 text-black mt-[6px] mb-[6px] xl:mb-0">{{psfCardInfo.location ? (((type
                        ==
                        'arrival' ? 'PARKIFLY.CHOOSE_PARKING.FROM' : 'PARKIFLY.CHOOSE_PARKING.TO') | transloco) + ' ' +
                        psfCardInfo.location) : '-'}}</p>
                </div>
                } @else {
                <div class="mt-3">
                    <p class="text-sm leading-5 text-gray-600 mb-[6px]">{{ day |
                        transloco }}
                    </p>
                    <p class="text-sm leading-6 text-black mb-[6px] xl:mb-0">{{parkingDate + ' ' +
                        ("PARKIFLY.CLOCK_SHORT" | transloco) + ': ' + parkingTime}}</p>
                </div>
                }
                }
                }
            </div>
        </div>
        }
    </div>
</div>